import { getCurrentCompanyId, getCurrentUserEmail, getCurrentUserId } from 'Lib/Utils';

export const debugInformation = (operation) => {
    return {
        companyId: getCurrentCompanyId(),
        userId: getCurrentUserId(),
        email: getCurrentUserEmail(),
        ...(operation && { operation }),
    };
};
